import { Component, Input, OnInit } from '@angular/core';
import { MBTI } from 'src/app/interfaces/mbti';

@Component({
  selector: 'app-bubble-content',
  templateUrl: './bubble-content.component.html',
  styleUrls: ['./bubble-content.component.scss'],
})
export class BubbleContentComponent implements OnInit {

  constructor() { }

  @Input() mbti: MBTI | undefined;
  @Input() radius: number | undefined;
  @Input() level: number | undefined;
  @Input() count: number | undefined;

  height = 0;
  width = 0;
  imageSize = 0;
  fontSize = 0;
  countFontSize = 0;

  ngOnInit() {
    this.calcHeight();
    this.calcWidth();
    this.calcImageSize(this.height);
    this.calcFontSize(this.height);
    this.calcCountFontSize(this.width);
  }

  calcHeight(): void {
    this.height = Math.min(32, (this.radius ?? 0) * 2 / 3)
  }
  calcWidth(): void {
    this.width = Math.min(84, (this.radius ?? 0) * 2 * 0.75)
  }
  calcImageSize(height: number): void {
    this.imageSize = Math.min(20, height * 0.6)
  }
  calcFontSize(height: number): void {
    this.fontSize = Math.min(16, height * 0.5)
  }
  calcCountFontSize(width: number): void {
    this.countFontSize = Math.min(18, width * 0.3)
  }

}
